import { useEffect, useState } from "react";
// components
import { ListaDocumentosTecnicos } from "./ListaDocumentosTecnicos";
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
// Hooks
import { UseVerConvocatorias } from "../../../../hooks/UseVerConvocatorias";
import { useDocumentosTecnicos } from "../../../../hooks/useDocumentosTecnicos";
// style component
import { Button, Modal, Input } from "antd";
import { CheckCircleOutlined, SaveOutlined } from "@ant-design/icons";
const { TextArea } = Input;
// style
import "../../Usuario.style.scss";
import { openNotification } from "../../../../utils/Notifactions";
import { useNavigate } from "react-router-dom";
import apiParticipantes from "../../../../api/Participantes/api-participantes";
import { useEncrypt } from "../../../../hooks/useEncrypt";
import moment from "moment";
interface IProps {
  /**
   * El wizard trae su propio stepper y sus propios botones, asi que no
   * necesita ni la introduccion ni la navegacion de la pagina.
   */
  mostrarIntro?: boolean;
  mostrarNavegacion?: boolean;
  /**
   * Se avisa cuando termina de guardarse un cambio en los documentos, para
   * que lo que dependa de ellos —los avisos del wizard— se entere sin que
   * haya que pedirlo.
   */
  alCambiarDocumentos?: () => void;
}

export const PanelDocumentosTecnicos = ({
  mostrarIntro = true,
  mostrarNavegacion = true,
  alCambiarDocumentos,
}: IProps) => {
  const navigate = useNavigate();
  const { decrypt } = useEncrypt();
  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
    descargarArchivo,
  } = UseVerConvocatorias();
  const {
    documentos,
    setDocumentos,
    guardarArchivosTecnicos,
    autoGuardarTecnicos,
    eliminarArchivo,
    consultarArchivos,
    loading,
  } = useDocumentosTecnicos();

  /** El documento que se esta viendo en el visor, por su nombre de archivo. */
  const [documentoEnElVisor, setDocumentoEnElVisor] = useState<string>("");

  const verDocumento = (archivo: string) => {
    if (archivo) setDocumentoEnElVisor(archivo);
  };

  const [documentosUsuario, setDocumentosUsuario] = useState<any>([]);
  const [modalEscritoVideo, setModalEscritoVideo] = useState(false);
  const [escrito, setEscrito] = useState("");
  const [urlVideo, setUrlVideo] = useState("");
  const [currentIndex, setCurrentIndex] = useState(-1);

  const getDocumentosTecnicos = async () => {
    const { data } = await apiParticipantes.consultarDocumentosTecnicos(decrypt(localStorage.getItem("id_postulacion")));
    console.log('data', data)
    setDocumentosUsuario(data.documentos_tecnicos);
  }

  useEffect(() => {
    getConvocatoriaPersistente();
    getDocumentosTecnicos();
  }, []);

  useEffect(() => {
    if (documentos.length > 0 && documentosUsuario && documentosUsuario.length > 0) {
      let haCambiado = false;
      const nuevosdocumentos = documentos.map((documento: any) => {
        const isEscritoVideo = documento.tipo_documento === "Escrito y Video";
        const matchingDoc = documentosUsuario.find((docU: any) => docU.tipo_documento === documento.tipo_documento);

        if (isEscritoVideo) {
          if ((!documento.escrito || documento.escrito === "") && matchingDoc && (matchingDoc.escrito || matchingDoc.url_video)) {
            haCambiado = true;
            return { ...documento, escrito: matchingDoc.escrito, url_video: matchingDoc.url_video };
          }
        } else if (!documento.url_participante || documento.url_participante === "") {
          if (matchingDoc?.url_participante && matchingDoc.url_participante !== "") {
            haCambiado = true;
            return { ...documento, url_participante: matchingDoc.url_participante };
          }
        }
        return documento;
      });

      if (haCambiado) {
        setDocumentos(nuevosdocumentos);
      }
    }
  }, [documentosUsuario, documentos]);

  return (
    <div>
      <div className="container-fluid2">
        {mostrarIntro && (
        <div className="row mt-4">
          <div className="col-12 no-margin font-family-Montserrat-Regular font-size-18px">
            <span className="font-family-Montserrat-SemiBold">
              Cargar los siguientes formatos PDF de documentación técnica.
            </span>{" "}
            Debes descargar los formatos, completarlos y posteriormente
            cargarlos para su envío.
          </div>
        </div>
        )}
        <div className="col-12 mt-4">
          <div className="row">
            <div className="col-2 font-family-Montserrat-Regular font-size-18px numero-seleccionar-postulacion background-seleccionar-postulacion-amarillo">
              4
            </div>
            <div className="col font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion">
              Documentación técnica.{" "}
              <span>Obligatorios</span>
            </div>
          </div>
        </div>
        <ListaDocumentosTecnicos
          acciones={{
            documentos,
            setDocumentos,
            // Igual que en administrativos: se avisa cuando ya quedo guardado.
            guardarArchivosTecnicos: async (...args: any[]) => {
              const hecho = await guardarArchivosTecnicos(
                ...(args as [any, any, number, any])
              );
              alCambiarDocumentos?.();
              return hecho;
            },
            eliminarArchivo: async (...args: any[]) => {
              const hecho = await eliminarArchivo(...(args as [any, number, any]));
              alCambiarDocumentos?.();
              return hecho;
            },
            descargarArchivo,
            verDocumento,
            documentosUsuario,
            setDocumentosUsuario,
            setCurrentIndex,
            setEscrito,
            setUrlVideo,
            setModalEscritoVideo,
          }}
        />
      </div>
      {mostrarNavegacion && (
      <div
        className="container-fluid2"
        style={{
          justifyContent: "center",
          //marginTop: "0.5%",
          position: "sticky",
          bottom: 0,
          paddingBottom: "0%",
        }}
      >
        <div className="col justify-content-flex-end">
          <Button
            style={{ marginRight: "1%" }}
            type="link"
            className="button-blanco-radius font-size-12px"
            onClick={() => consultarArchivos(true)}
            disabled={loading}
          >
            Guardar y salir
            {loading && (
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
              />
            )}
          </Button>
          <Button
            style={{ marginRight: "1%" }}
            type="link"
            className="button-blanco-radius font-size-12px"
            onClick={() => navigate("/usuario/Documentosadministrativos")}
          >
            Atrás
          </Button>
          <Button
            type="link"
            className="button-azul-radius font-size-12px"
            onClick={() => {
              consultarArchivos(false)
            }}
            disabled={loading}
          >
            Continuar
            {loading && (
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
              />
            )}
          </Button>
        </div>
      </div>
      )}
      <ModalVisualizarDocumentos
        visualizar={documentoEnElVisor !== ""}
        setVisualizar={() => setDocumentoEnElVisor("")}
        state={{ documento: documentoEnElVisor }}
      />

      <Modal
        title={
          <div className="font-family-Montserrat-Bold font-size-22px color-0050A0 d-flex align-items-center">
            <SaveOutlined style={{ marginRight: '12px', fontSize: '26px' }} />
            Diligenciar Escrito o Narración
          </div>
        }
        visible={modalEscritoVideo}
        onCancel={() => setModalEscritoVideo(false)}
        width={900}
        centered
        className="modal-custom-escrito"
        footer={[
          <Button
            key="back"
            onClick={() => setModalEscritoVideo(false)}
            className="button-blanco-radius"
            style={{ height: '40px', padding: '0 25px' }}
          >
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            style={{ background: "#0CA45D", borderColor: "#0CA45D", height: '40px', padding: '0 30px' }}
            className="button-azul-radius"
            onClick={async () => {
              if (escrito.trim() === "" || urlVideo.trim() === "") {
                return openNotification({
                  titulo: "Error",
                  descripcion: "Todos los campos son obligatorios para guardar la narración.",
                  placement: "bottomRight",
                });
              }
              const nuevosdocumentos = documentos.map((doc: any, i: number) => {
                if (i === currentIndex) {
                  return {
                    ...doc,
                    escrito,
                    url_video: urlVideo,
                    fecha: moment().format("YYYY-MM-DD"),
                    hora: moment().format("HH:mm")
                  };
                }
                return doc;
              });
              setDocumentos(nuevosdocumentos);
              setModalEscritoVideo(false);

              // Esto solo actualizaba la pantalla. Lo guardaban los botones
              // de navegacion de la pagina, que el wizard oculta, asi que
              // ahi la narracion se perdia al cerrar.
              await autoGuardarTecnicos(nuevosdocumentos);
              alCambiarDocumentos?.();
              if (document.getElementsByClassName("cards-documentos")[currentIndex]) {
                document
                  .getElementsByClassName("cards-documentos")
                [currentIndex].classList.remove("border-error-cards-documentos");
              }
            }}
          >
            Guardar Formato
          </Button>
        ]}
      >
        <div className="p-3">
          <div className="mb-4">
            <span className="font-family-Montserrat-SemiBold font-size-16px mb-2 d-block color-707070">
              Escrito o Narración de la Propuesta:
            </span>
            <p className="font-family-Montserrat-Regular font-size-13px color-707070 mb-2">
              Ingrese el texto descriptivo de su propuesta. Máximo 10,000 caracteres.
            </p>
            <TextArea
              rows={12}
              maxLength={10000}
              value={escrito}
              onChange={(e) => setEscrito(e.target.value)}
              showCount
              placeholder="Escriba aquí su narración..."
              className="mt-1 font-family-Montserrat-Regular"
              style={{ borderRadius: '8px', padding: '12px', border: '1px solid #d9d9d9' }}
            />
          </div>
          <div className="mt-5">
            <span className="font-family-Montserrat-SemiBold font-size-16px mb-2 d-block color-707070">
              URL del video de soporte:
            </span>
            <p className="font-family-Montserrat-Regular font-size-13px color-707070 mb-2">
              Asegúrese de que el enlace sea público o tenga permisos de visualización (YouTube, Vimeo, Google Drive, etc.)
            </p>
            <p className="font-family-Montserrat-Regular font-size-13px color-707070 mb-2">
              ¡Muéstranos tu esencia! Graba un video de máximo 3 (tres) minutos en el que, de manera clara y concisa, expliques por qué tu liderazgo debe ser reconocido. <br />
              🎥 Puedes grabarlo con un celular inteligente, no es necesario que sea grabado por un profesional.<br />
              📐 Formato: MP4, pega el link de Drive o Youtube.<br />
              📏 Mantén tu video dentro del tiempo establecido.<br />
              🎤 Se recomienda grabar en horizontal para una mejor visualización.<br />
              💡 Grábalo en un lugar bien iluminado y sin ruidos.<br />
              📱 Limpia la cámara antes de grabar para una mejor calidad de imagen.
            </p>
            <Input
              placeholder="https://example.com/mi-video"
              value={urlVideo}
              onChange={(e) => setUrlVideo(e.target.value)}
              className="mt-1 font-family-Montserrat-Regular"
              prefix={<i className="fa fa-link color-adb5bd mr-2" />}
              style={{ borderRadius: '8px', height: '45px', border: '1px solid #d9d9d9' }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};
